import { ConnectHttpTransport } from '@ofs-vuex-crud';
import config from '@/config';

const providerInstance = new ConnectHttpTransport({ apiBase: config.apiBase });

export default providerInstance;
